var _linearGradient, _linearGradient2, _linearGradient3, _linearGradient4, _linearGradient5, _linearGradient6, _linearGradient7, _linearGradient8, _linearGradient9, _linearGradient10, _linearGradient11, _linearGradient12, _linearGradient13, _linearGradient14, _linearGradient15, _linearGradient16, _linearGradient17, _linearGradient18, _linearGradient19, _linearGradient20, _linearGradient21, _linearGradient22, _linearGradient23, _linearGradient24, _linearGradient25, _linearGradient26, _linearGradient27, _linearGradient28, _linearGradient29, _linearGradient30, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconPassword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    height: "511pt",
    viewBox: "1 -24 511.999 511",
    width: "511pt",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _linearGradient || (_linearGradient = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg1"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f9f7fc"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#f0ddfc"
  }))), _linearGradient2 || (_linearGradient2 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear0",
    gradientUnits: "userSpaceOnUse",
    x1: 200.556509706,
    x2: 326.046759706,
    xlinkHref: "#lg1",
    y1: 119.2970137668,
    y2: 437.5402877668
  })), _linearGradient3 || (_linearGradient3 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg2"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f0ddfc",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.2889,
    stopColor: "#c8b7e0",
    stopOpacity: 0.290196
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.5915,
    stopColor: "#a595c8",
    stopOpacity: 0.592157
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.8395,
    stopColor: "#8f81b8",
    stopOpacity: 0.839216
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#8779b3"
  }))), _linearGradient4 || (_linearGradient4 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear1",
    gradientUnits: "userSpaceOnUse",
    x1: 275.243286896,
    x2: 205.9760822308,
    xlinkHref: "#lg2",
    y1: 220.721345975,
    y2: -226.5035175644
  })), _linearGradient5 || (_linearGradient5 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear2",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    xlinkHref: "#lg2",
    y1: 391.8792046174,
    y2: 507.8655258278
  })), _linearGradient6 || (_linearGradient6 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear3",
    gradientUnits: "userSpaceOnUse",
    x1: 253.1055016974,
    x2: 260.1330560896,
    y1: 17.091329066,
    y2: 115.475685066
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient7 || (_linearGradient7 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear4",
    gradientUnits: "userSpaceOnUse",
    x1: 256.00011,
    x2: 256.00011,
    y1: 81.0399557596,
    y2: 130.7878045866
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#b53759",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#b53759"
  }))), _linearGradient8 || (_linearGradient8 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear5",
    gradientUnits: "userSpaceOnUse",
    x1: 53.8771807974,
    x2: 25.4819497728,
    xlinkHref: "#lg1",
    y1: 67.6542621648,
    y2: 39.2591315324
  })), _linearGradient9 || (_linearGradient9 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear6",
    gradientUnits: "userSpaceOnUse",
    x1: 61.741203,
    x2: 20.8807744624,
    xlinkHref: "#lg2",
    y1: 75.5183847596,
    y2: 34.657956222
  })), _linearGradient10 || (_linearGradient10 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear7",
    gradientUnits: "userSpaceOnUse",
    x1: 33.2130527026,
    x2: 51.7415375268,
    y1: 46.9902344622,
    y2: 65.5186188942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffc738"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#e97264"
  }))), _linearGradient11 || (_linearGradient11 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear8",
    gradientUnits: "userSpaceOnUse",
    x1: 99.7228852026,
    x2: 71.3277545702,
    xlinkHref: "#lg1",
    y1: 67.6542621648,
    y2: 39.2591315324
  })), _linearGradient12 || (_linearGradient12 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear9",
    gradientUnits: "userSpaceOnUse",
    x1: 107.5870077974,
    x2: 66.7265792598,
    xlinkHref: "#lg2",
    y1: 75.5183847596,
    y2: 34.657956222
  })), _linearGradient13 || (_linearGradient13 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg3"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#ffb5b0"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#ff70ac"
  }))), _linearGradient14 || (_linearGradient14 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear10",
    gradientUnits: "userSpaceOnUse",
    x1: 79.0588575,
    x2: 97.587241932,
    xlinkHref: "#lg3",
    y1: 46.9902344622,
    y2: 65.5186188942
  })), _linearGradient15 || (_linearGradient15 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear11",
    gradientUnits: "userSpaceOnUse",
    x1: 145.56869,
    x2: 117.1734589754,
    xlinkHref: "#lg1",
    y1: 67.6542621648,
    y2: 39.2591315324
  })), _linearGradient16 || (_linearGradient16 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear12",
    gradientUnits: "userSpaceOnUse",
    x1: 153.4327122026,
    x2: 112.572283665,
    xlinkHref: "#lg2",
    y1: 75.5183847596,
    y2: 34.657956222
  })), _linearGradient17 || (_linearGradient17 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear13",
    gradientUnits: "userSpaceOnUse",
    x1: 124.9046622974,
    x2: 143.4330467294,
    y1: 46.9902344622,
    y2: 65.5186188942
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#af9ce6"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.1591,
    stopColor: "#ab9ce7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.3136,
    stopColor: "#9f9be8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.4663,
    stopColor: "#8c9beb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.6178,
    stopColor: "#709aef"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.7686,
    stopColor: "#4d99f5"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.9167,
    stopColor: "#2297fb"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#0796ff"
  }))), _linearGradient18 || (_linearGradient18 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear14",
    gradientUnits: "userSpaceOnUse",
    x1: 312.4116918864,
    x2: 263.2195138864,
    xlinkHref: "#lg2",
    y1: 493.8061001788,
    y2: 219.7353941788
  })), _linearGradient19 || (_linearGradient19 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg4"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#3b395f"
  }))), _linearGradient20 || (_linearGradient20 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear15",
    gradientUnits: "userSpaceOnUse",
    x1: 245.6936459636,
    x2: 287.8583699636,
    xlinkHref: "#lg4",
    y1: 207.8222533736,
    y2: 410.6144973736
  })), _linearGradient21 || (_linearGradient21 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear16",
    gradientTransform: "matrix(-1.003922 0 0 -1.003922 512 547.0083)",
    gradientUnits: "userSpaceOnUse",
    x1: 244.2649,
    x2: 274.1525,
    xlinkHref: "#lg4",
    y1: 236.855,
    y2: 380.6004
  })), _linearGradient22 || (_linearGradient22 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "lg5"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#4f4a72",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#2e224a"
  }))), _linearGradient23 || (_linearGradient23 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear17",
    gradientUnits: "userSpaceOnUse",
    x1: 221.6836466272,
    x2: 100.8656496152,
    xlinkHref: "#lg5",
    y1: 353.3970672978,
    y2: 232.5790702858
  })), _linearGradient24 || (_linearGradient24 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear18",
    gradientUnits: "userSpaceOnUse",
    x1: 305.6319054438,
    x2: 184.8139084318,
    xlinkHref: "#lg5",
    y1: 353.3970672978,
    y2: 232.5790702858
  })), _linearGradient25 || (_linearGradient25 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear19",
    gradientUnits: "userSpaceOnUse",
    x1: 389.182410364,
    x2: 268.3643129598,
    xlinkHref: "#lg5",
    y1: 353.3970672978,
    y2: 232.5790702858
  })), _linearGradient26 || (_linearGradient26 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear20",
    gradientUnits: "userSpaceOnUse",
    x1: 471.6339218708,
    x2: 352.0741403014,
    xlinkHref: "#lg5",
    y1: 352.188445602,
    y2: 232.6286640326
  })), _linearGradient27 || (_linearGradient27 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear21",
    gradientUnits: "userSpaceOnUse",
    x1: 92.8456179338,
    x2: 167.6467418396,
    xlinkHref: "#lg3",
    y1: 257.3913036924,
    y2: 257.3913036924
  })), _linearGradient28 || (_linearGradient28 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear22",
    gradientUnits: "userSpaceOnUse",
    x1: 176.742977905,
    x2: 251.5441018108,
    xlinkHref: "#lg3",
    y1: 257.3913036924,
    y2: 257.3913036924
  })), _linearGradient29 || (_linearGradient29 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear23",
    gradientUnits: "userSpaceOnUse",
    x1: 260.2789259562,
    x2: 335.080049862,
    xlinkHref: "#lg3",
    y1: 257.3913036924,
    y2: 257.3913036924
  })), _linearGradient30 || (_linearGradient30 = /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear24",
    gradientUnits: "userSpaceOnUse",
    x1: 344.010438013,
    x2: 418.8115619188,
    xlinkHref: "#lg3",
    y1: 257.3913036924,
    y2: 257.3913036924
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m478.914062 463.050781h-445.828124c-15.796876 0-28.601563-12.804687-28.601563-28.601562v-349.09375c0-15.796875 12.804687-28.601563 28.601563-28.601563h445.832031c15.792969 0 28.601562 12.804688 28.601562 28.601563v349.09375c-.003906 15.796875-12.808593 28.601562-28.605469 28.601562zm0 0",
    fill: "url(#linear0)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "m507.523438 85.359375v349.09375c0 15.792969-12.8125 28.601563-28.601563 28.601563h-121.164063l-353.238281-353.238282-.042969.007813v-24.464844c0-15.800781 12.8125-28.601563 28.601563-28.601563h445.84375c15.789063 0 28.601563 12.800782 28.601563 28.601563zm0 0",
    fill: "url(#linear1)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "m4.484375 342.1875v92.261719c0 15.796875 12.804687 28.601562 28.601563 28.601562h445.832031c15.792969 0 28.601562-12.804687 28.601562-28.601562v-92.261719zm0 0",
    fill: "url(#linear2)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "m495.121094 114.730469h-478.242188c-9.320312 0-16.878906-7.558594-16.878906-16.878907v-80.472656c0-9.324218 7.558594-16.878906 16.878906-16.878906h478.242188c9.320312 0 16.878906 7.558594 16.878906 16.878906v80.472656c0 9.320313-7.558594 16.878907-16.878906 16.878907zm0 0",
    fill: "url(#linear3)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "m0 54.601562v43.25c0 9.320313 7.558594 16.878907 16.878906 16.878907h478.242188c9.320312 0 16.878906-7.558594 16.878906-16.878907v-43.25zm0 0",
    fill: "url(#linear4)"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "m58.898438 52.929688c0 10.90625-8.839844 19.746093-19.746094 19.746093-10.902344 0-19.742188-8.839843-19.742188-19.746093 0-10.902344 8.839844-19.742188 19.742188-19.742188 10.90625 0 19.746094 8.839844 19.746094 19.742188zm0 0",
    fill: "url(#linear5)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "m48.003906 44.550781c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738282 0-12.199219 5.460937-12.199219 12.199219 0 3.492187 1.472656 6.628906 3.820313 8.851562l23.652343 23.652344c2.222657 2.347656 5.363281 3.824218 8.851563 3.824218 6.738281 0 12.203125-5.464843 12.203125-12.203124 0-3.488282-1.472657-6.628907-3.824219-8.851563zm0 0",
    fill: "url(#linear6)"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "m51.355469 52.929688c0 6.738281-5.464844 12.203124-12.203125 12.203124-6.738282 0-12.199219-5.464843-12.199219-12.203124 0-6.738282 5.460937-12.199219 12.199219-12.199219 6.738281 0 12.203125 5.460937 12.203125 12.199219zm0 0",
    fill: "url(#linear7)"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "m104.742188 52.929688c0 10.90625-8.839844 19.746093-19.742188 19.746093-10.90625 0-19.746094-8.839843-19.746094-19.746093 0-10.902344 8.839844-19.742188 19.746094-19.742188 10.902344 0 19.742188 8.839844 19.742188 19.742188zm0 0",
    fill: "url(#linear8)"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "m93.851562 44.550781c-2.222656-2.347656-5.363281-3.820312-8.851562-3.820312-6.738281 0-12.203125 5.460937-12.203125 12.199219 0 3.492187 1.472656 6.628906 3.824219 8.851562l23.648437 23.652344c2.226563 2.347656 5.363281 3.824218 8.855469 3.824218 6.738281 0 12.199219-5.464843 12.199219-12.203124 0-3.488282-1.472657-6.628907-3.820313-8.851563zm0 0",
    fill: "url(#linear9)"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "m97.199219 52.929688c0 6.738281-5.460938 12.203124-12.199219 12.203124s-12.203125-5.464843-12.203125-12.203124c0-6.738282 5.464844-12.199219 12.203125-12.199219s12.199219 5.460937 12.199219 12.199219zm0 0",
    fill: "url(#linear10)"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "m150.589844 52.929688c0 10.90625-8.839844 19.746093-19.746094 19.746093-10.902344 0-19.742188-8.839843-19.742188-19.746093 0-10.902344 8.839844-19.742188 19.742188-19.742188 10.90625 0 19.746094 8.839844 19.746094 19.742188zm0 0",
    fill: "url(#linear11)"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "m139.699219 44.550781c-2.226563-2.347656-5.363281-3.820312-8.855469-3.820312-6.738281 0-12.199219 5.460937-12.199219 12.199219 0 3.492187 1.472657 6.628906 3.820313 8.851562l23.652344 23.652344c2.222656 2.347656 5.363281 3.824218 8.851562 3.824218 6.738281 0 12.203125-5.464843 12.203125-12.203124 0-3.488282-1.472656-6.628907-3.824219-8.851563zm0 0",
    fill: "url(#linear12)"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "m143.046875 52.929688c0 6.738281-5.464844 12.203124-12.203125 12.203124s-12.203125-5.464843-12.203125-12.203124c0-6.738282 5.464844-12.199219 12.203125-12.199219s12.203125 5.460937 12.203125 12.199219zm0 0",
    fill: "url(#linear13)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "m507.515625 434.449219v-205.132813l-39.039063-39.039062c-6.453124-8.332032-16.546874-13.703125-27.902343-13.703125h-369.148438c-19.488281 0-35.285156 15.796875-35.285156 35.285156v91.0625c0 11.355469 5.371094 21.449219 13.699219 27.902344l132.226562 132.226562h296.847656c15.796876 0 28.601563-12.804687 28.601563-28.601562zm0 0",
    fill: "url(#linear14)"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "m440.574219 338.207031h-369.148438c-19.488281 0-35.285156-15.796875-35.285156-35.285156v-91.0625c0-19.488281 15.796875-35.28125 35.285156-35.28125h369.148438c19.488281 0 35.285156 15.796875 35.285156 35.28125v91.0625c0 19.488281-15.796875 35.285156-35.285156 35.285156zm0 0",
    fill: "url(#linear15)"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "m88.21875 207.476562h335.5625c14.378906 0 26.035156 11.65625 26.035156 26.035157v47.757812c0 14.378907-11.65625 26.035157-26.035156 26.035157h-335.5625c-14.378906 0-26.035156-11.65625-26.035156-26.035157v-47.757812c0-14.378907 11.65625-26.035157 26.035156-26.035157zm0 0",
    fill: "url(#linear16)"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m165.605469 244.800781c-1.363281-1.75-3.035157-2.628906-5.011719-2.628906-.371094 0-1.054688.125-2.042969.367187l-2.960937 1.078126c-.167969-.179688-20.222656-20.199219-20.222656-20.199219-1.351563-1.109375-3.058594-1.667969-5.125-1.667969-2.066407 0-3.804688.582031-5.21875 1.734375-1.40625 1.15625-2.175782 2.828125-2.296876 5.007813l.925782 22.722656-22.632813-7.640625c-.261719-.246094-2.101562 1.347656-2.417969 1.347656-.886718 0-.617187-.027344-1.191406 1.539063-.574218 1.566406-1.066406 1.164062-1.066406 3.167968 0 3.410156-2.226562 3.761719-1.949219 6.152344 0 0 17.332031 16.347656 17.6875 16.730469l-6.492187 9.195312c-.953125 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.917969 3.804688 2.757813 5.105469.09375.066407 27.554687 27.53125 47.136719 47.125h104.957031zm0 0",
    fill: "url(#linear17)"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m249.554688 244.800781c-1.363282-1.75-3.035157-2.628906-5.011719-2.628906-.371094 0-1.054688.125-2.042969.367187l-2.960938 1.078126c-.167968-.179688-20.222656-20.199219-20.222656-20.199219-1.351562-1.109375-3.058594-1.667969-5.125-1.667969s-3.804687.582031-5.21875 1.734375c-1.40625 1.15625-2.175781 2.828125-2.296875 5.007813l.925781 22.722656-22.632812-7.640625c-.261719-.246094-2.101562 1.347656-2.417969 1.347656-.886719 0-.617187-.027344-1.191406 1.539063-.574219 1.566406-1.066406 1.164062-1.066406 3.167968 0 3.410156-2.226563 3.761719-1.953125 6.152344 0 0 16.988281 16.683594 17.347656 17.070312l-6.144531 8.855469c-.957031 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.914063 3.804688 2.753907 5.105469.097656.066407 27.554687 27.53125 47.136718 47.125h104.957032zm0 0",
    fill: "url(#linear18)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "m333.105469 244.800781c-1.363281-1.75-3.035157-2.628906-5.011719-2.628906-.371094 0-1.054688.125-2.042969.367187l-2.960937 1.078126c-.167969-.179688-20.226563-20.199219-20.226563-20.199219-1.347656-1.109375-3.054687-1.667969-5.121093-1.667969-2.066407 0-3.808594.582031-5.21875 1.734375-1.410157 1.15625-2.175782 2.828125-2.296876 5.007813l.925782 22.722656-22.632813-7.640625c-.261719-.246094-2.105469 1.347656-2.417969 1.347656-.886718 0-.617187-.027344-1.191406 1.539063-.574218 1.566406-1.066406 1.164062-1.066406 3.167968 0 3.410156-2.230469 3.761719-1.953125 6.152344 0 0 16.988281 16.683594 17.347656 17.070312l-6.148437 8.855469c-.953125 1.238281-1.425782 2.664063-1.425782 4.269531 0 2.105469.914063 3.804688 2.753907 5.105469.09375.066407 27.554687 27.53125 47.136719 47.125h104.957031zm0 0",
    fill: "url(#linear19)"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "m416.765625 244.800781c-1.363281-1.75-3.035156-2.628906-5.011719-2.628906-.371094 0-1.054687.125-2.042968.367187l-2.960938 1.078126c-.167969-.179688-20.226562-20.199219-20.226562-20.199219-1.347657-1.109375-3.054688-1.667969-5.121094-1.667969s-3.808594.582031-5.21875 1.734375c-1.410156 1.15625-2.175782 2.828125-2.300782 5.007813l.929688 22.722656-22.636719-7.640625c-.257812-.246094-2.101562 1.347656-2.414062 1.347656-.886719 0-.617188-.027344-1.191407 1.539063-.574218 1.566406-1.066406 1.164062-1.066406 3.167968 0 3.410156-2.230468 3.761719-1.953125 6.152344 0 0 16.988281 16.683594 17.347657 17.070312l-6.148438 8.855469c-.953125 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.917969 3.804688 2.757813 5.105469.09375.066407 27.554687 27.53125 47.132813 47.125h102.3125l-.003907-2.652343zm0 0",
    fill: "url(#linear20)"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m165.605469 244.800781c-1.363281-1.75-3.035157-2.628906-5.011719-2.628906-.371094 0-1.054688.125-2.042969.367187l-21.71875 7.90625.742188-22.214843c-.125-2.097657-.859375-3.699219-2.207031-4.8125-1.351563-1.109375-3.058594-1.667969-5.125-1.667969-2.066407 0-3.804688.582031-5.21875 1.734375-1.40625 1.15625-2.175782 2.828125-2.296876 5.007813l.925782 22.714843-21.710938-7.902343c-.988281-.246094-1.671875-.371094-2.042968-.371094-1.976563 0-3.648438.878906-5.011719 2.628906-1.359375 1.757812-2.042969 3.699219-2.042969 5.832031 0 3.257813 1.550781 5.265625 4.640625 6.015625l21.332031 5.566406-13.222656 18.730469c-.953125 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.917969 3.804688 2.753907 5.105469 1.835937 1.300781 3.671875 1.949219 5.511719 1.949219 2.078124 0 3.609374-.804688 4.589843-2.414062l13.222657-19.859376 13.460937 19.675782c1.113281 1.734375 2.78125 2.597656 5.011719 2.597656 2.101562 0 3.988281-.679688 5.660156-2.042969 1.671875-1.359375 2.507812-3.089843 2.507812-5.195312 0-1.734375-.371093-3.03125-1.117187-3.898438l-14.105469-19.675781 21.347656-5.570312c3.089844-.75 4.640626-2.757813 4.640626-6.019532 0-2.128906-.683594-4.074218-2.042969-5.828125zm0 0",
    fill: "url(#linear21)"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m249.503906 244.800781c-1.363281-1.75-3.035156-2.628906-5.011718-2.628906-.371094 0-1.054688.125-2.042969.367187l-21.71875 7.90625.742187-22.214843c-.125-2.097657-.859375-3.699219-2.210937-4.8125-1.347657-1.109375-3.054688-1.667969-5.121094-1.667969s-3.808594.582031-5.21875 1.734375c-1.410156 1.15625-2.175781 2.828125-2.296875 5.007813l.925781 22.714843-21.710937-7.902343c-.992188-.246094-1.671875-.371094-2.042969-.371094-1.980469 0-3.648437.878906-5.011719 2.628906-1.359375 1.757812-2.042968 3.699219-2.042968 5.832031 0 3.257813 1.550781 5.265625 4.640624 6.015625l21.332032 5.566406-13.222656 18.730469c-.957032 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.914062 3.804688 2.753906 5.105469 1.835938 1.300781 3.671875 1.949219 5.511719 1.949219 2.078125 0 3.609375-.804688 4.589844-2.414062l13.222656-19.859376 13.460937 19.675782c1.113282 1.734375 2.78125 2.597656 5.011719 2.597656 2.101563 0 3.988281-.679688 5.660157-2.042969 1.671874-1.359375 2.507812-3.089843 2.507812-5.195312 0-1.734375-.375-3.03125-1.117188-3.898438l-14.105468-19.675781 21.347656-5.570312c3.089844-.75 4.636719-2.757813 4.636719-6.019532 0-2.128906-.679688-4.074218-2.039063-5.828125zm0 0",
    fill: "url(#linear22)"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "m333.039062 244.800781c-1.363281-1.75-3.035156-2.628906-5.011718-2.628906-.371094 0-1.054688.125-2.042969.367187l-21.71875 7.90625.742187-22.214843c-.121093-2.097657-.859374-3.699219-2.207031-4.8125-1.347656-1.109375-3.058593-1.667969-5.121093-1.667969-2.070313 0-3.808594.582031-5.21875 1.734375-1.410157 1.15625-2.179688 2.828125-2.300782 5.007813l.925782 22.714843-21.710938-7.902343c-.988281-.246094-1.671875-.371094-2.042969-.371094-1.976562 0-3.648437.878906-5.011719 2.628906-1.359374 1.757812-2.039062 3.699219-2.039062 5.832031 0 3.257813 1.546875 5.265625 4.636719 6.015625l21.332031 5.566406-13.222656 18.730469c-.953125 1.238281-1.429688 2.664063-1.429688 4.269531 0 2.105469.917969 3.804688 2.753906 5.105469 1.835938 1.300781 3.671876 1.949219 5.511719 1.949219 2.078125 0 3.609375-.804688 4.589844-2.414062l13.226563-19.859376 13.457031 19.675782c1.113281 1.734375 2.785156 2.597656 5.011719 2.597656 2.101562 0 3.988281-.679688 5.660156-2.042969 1.671875-1.359375 2.507812-3.089843 2.507812-5.195312 0-1.734375-.371094-3.03125-1.113281-3.898438l-14.109375-19.675781 21.347656-5.570312c3.089844-.75 4.640625-2.757813 4.640625-6.019532-.003906-2.128906-.683593-4.074218-2.042969-5.828125zm0 0",
    fill: "url(#linear23)"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "m416.769531 244.800781c-1.363281-1.75-3.035156-2.628906-5.011719-2.628906-.371093 0-1.050781.125-2.042968.367187l-21.714844 7.90625.742188-22.214843c-.125-2.097657-.863282-3.699219-2.210938-4.8125-1.347656-1.109375-3.058594-1.667969-5.121094-1.667969-2.070312 0-3.808594.582031-5.21875 1.734375-1.410156 1.15625-2.179687 2.828125-2.300781 5.007813l.925781 22.714843-21.710937-7.902343c-.988281-.246094-1.671875-.371094-2.042969-.371094-1.976562 0-3.648438.878906-5.011719 2.628906-1.359375 1.757812-2.039062 3.699219-2.039062 5.832031 0 3.257813 1.546875 5.265625 4.640625 6.015625l21.328125 5.566406-13.222657 18.730469c-.953124 1.238281-1.429687 2.664063-1.429687 4.269531 0 2.105469.917969 3.804688 2.753906 5.105469 1.839844 1.300781 3.671875 1.949219 5.511719 1.949219 2.078125 0 3.613281-.804688 4.589844-2.414062l13.226562-19.859376 13.457032 19.675782c1.113281 1.734375 2.785156 2.597656 5.011718 2.597656 2.101563 0 3.992188-.679688 5.660156-2.042969 1.671876-1.359375 2.507813-3.089843 2.507813-5.195312 0-1.734375-.371094-3.03125-1.113281-3.898438l-14.109375-19.675781 21.347656-5.570312c3.09375-.75 4.640625-2.757813 4.640625-6.019532 0-2.128906-.683594-4.074218-2.042969-5.828125zm0 0",
    fill: "url(#linear24)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPassword);
export default __webpack_public_path__ + "static/media/icon-password.7d7293f5c4da28bba5f9c1cdcf02e56f.svg";
export { ForwardRef as ReactComponent };